import React, { useState, useEffect, useRef } from "react";
import myImage from "../../assets/arrow.svg";
import smartNotificationsImg1 from "../../assets/2.webp";
import smartNotificationsImg2 from "../../assets/3.webp";
import smartNotificationsImg3 from "../../assets/4.webp";
import smartNotificationsImg4 from "../../assets/1.webp";

import "./Real.css";

const SlideUpCards = () => {
  const [currentCard, setCurrentCard] = useState(1);
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  const sectionData = [
    {
      id: 1,
      title: "Smart Route Optimization",
      text: (
        <>
          <strong className="">We find the fastest way — so you don’t have to</strong> <br/><br/>
            No more wasted time or fuel on roundabout routes. Packky (powered by Chaafo) uses smart
            route planning to make sure your deliveries take the quickest, most
            efficient path.
            <br />
            <br />
            It helps you avoid delays, reduce costs, and get things done faster.
            Whether it’s a single drop or multiple stops, your deliveries move
            smoothly and on time.
        </>
      ),
      images: smartNotificationsImg1,
    },
    {
      id: 2,
      title: "Order Synchronization",
      text: (
        <>
         <strong className="">All your deliveries, organized in one place</strong> <br/><br/>
            
          If you're managing multiple deliveries every day, we’ve got your back.
          Packky (powered by Chaafo) brings all your orders together in one dashboard, so you can
          schedule, track, and repeat without jumping between tools.
          <br />
          <br />
          Whether you're delivering to customers, vendors, or branches,
          everything stays neat, synced, and easy to manage.
        </>
      ),
      images: smartNotificationsImg2,
    },
    {
      id: 3,
      title: "Flexible Vehicle Options",
      text: (
        <>
         <strong className="">Choose the right vehicle for every delivery</strong> <br/><br/>
          
          Different deliveries need different rides. With Packky (powered by Chaafo), you can choose
          from two-wheelers for small packages, three-wheelers for medium loads,
          or mini-trucks for bigger deliveries.
          <br />
          <br />
          We’ll help you pick what fits best based on size, weight, and urgency
          — saving you both time and cost.
        </>
      ),
      images: smartNotificationsImg3,
    },
    {
      id: 4,
      title: "Real-Time Tracking",
      text: (
        <>
         <strong className="">Stay updated every step of the way</strong> <br/><br/>
          
          With Packky (powered by Chaafo), you always know where your parcel is. From the moment
          it's picked up to the moment it’s delivered, real-time tracking keeps
          you and your customers in the loop.
          <br />
          <br />
          Whether you're sending something across town or across multiple zones,
          you'll get live updates so you're never left guessing. It’s reliable,
          transparent, and made to build trust with every delivery.
        </>
      ),
      images: smartNotificationsImg4,
    },
  ];

  // const headings = [
  //   "Smart Route Optimization",
  //   "Order Synchronization",
  //   "Driver Coordination",
  //   "Real-Time Tracking",
  // ];

  const gradientClasses = [
    "gradient-blue",
    "gradient-orange",
    "gradient-red",
    "gradient-purple",
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || cardRefs.current.length === 0) return;

      let newCardIndex = 0;
      const screenHeight = window.innerHeight;

      const viewportCenterSmallScreen =
        screenHeight < 600 ? screenHeight / 5 : screenHeight / 7;
      const viewportCenterLargeScreen =
        screenHeight < 600 ? screenHeight / 3 : screenHeight / 6;

      cardRefs.current.forEach((cardRef, index) => {
        if (!cardRef) return;
        const rect = cardRef.getBoundingClientRect();

        if (
          (rect.top <= viewportCenterSmallScreen &&
            rect.bottom >= viewportCenterSmallScreen) ||
          (rect.top <= viewportCenterLargeScreen &&
            rect.bottom >= viewportCenterLargeScreen)
        ) {
          newCardIndex = index;
        }
      });

      setCurrentCard(newCardIndex + 1);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section
      ref={sectionRef}
      id="real-time-section"
      className="real-time py-5"
      style={{ backgroundColor: "#f4f4f4" }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="font-sans">
              <div className="section-heading-container mb-5">
                <h5
                  className="section-heading fw-bold"
                  style={{ fontSize: "26px" }}
                >
                  Deliver More, Stress Less with Packky (powered by Chaafo)
                </h5>
              </div>

              <div className="section-container">
                <div className="sticky-container mb-5">
                  {sectionData.map((card, index) => (
                    <div
                      key={card.id}
                      ref={(el) => (cardRefs.current[index] = el)}
                      className={`sticky-card ${gradientClasses[index]}`}
                    >
                      <div className="card-header">
                        <div className="header-left">
                          <button className="icon-button">
                            <img
                              src={myImage}
                              alt="Packky Logo"
                              className="icon-image"
                            />
                          </button>
                          <h5 className="card-title">
                            {card.title || "Default Heading"}
                          </h5>
                        </div>
                        <div>
                          <button className="counter-button">
                            {currentCard} / {sectionData.length}
                          </button>
                        </div>
                      </div>

                      <div className="card-body-container">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col-12 col-md-6 order-md-1 order-1 mb-4 mb-md-0">
                              <div className="card-text-container">
                                <p className="card-text">{card.text}</p>
                              </div>
                            </div>

                            <div className="col-12 col-md-6 order-md-2 order-2 p-0 ">
                              <div className="image-container">
                                <div className="image-wrapper">
                                  <img
                                    src={card.images}
                                    alt={card.title}
                                    className="card-image img-fluid"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlideUpCards;
